import { ICardsdestinosItem, IpaginatedCardsdestinos } from '../models'

export enum CardsdestinosActionTypes {
  SEARCH_CARDSDESTINOS = 'cardsdestinos/search',
  SEARCHING_CARDSDESTINOS = 'cardsdestinos/searching',
  FOUND_CARDSDESTINOS = 'cardsdestinos/found',
  SEARCHING_CARDSDESTINOS_FAILED = 'cardsdestinos/searching_failed',

  LOAD_CARDSDESTINOS = 'cardsdestinos/load',
  LOADING_CARDSDESTINOS = 'cardsdestinos/loading',
  LOADED_CARDSDESTINOS = 'cardsdestinos/loaded',
  LOADING_CARDSDESTINOS_FAILED = 'cardsdestinos/loading_failed',

  ADD_CARDSDESTINOS = 'cardsdestinos/add',
  ADDING_CARDSDESTINOS = 'cardsdestinos/adding',
  ADDED_CARDSDESTINOS = 'cardsdestinos/added',
  ADDING_CARDSDESTINOS_FAILED = 'cardsdestinos/adding_failed',

  REMOVE_CARDDESTINO = 'cardsdestinos/remove',
  REMOVING_CARDDESTINO = 'cardsdestinos/removing',
  REMOVED_CARDDESTINO = 'cardsdestinos/removed',
  REMOVING_CARDDESTINO_FAILED = 'cardsdestinos/removing_failed',

  SOFT_REMOVE_CARDSDESTINOS = 'cardsdestinos/soft_remove',
  SOFT_REMOVING_CARDSDESTINOS = 'cardsdestinos/soft_removing',
  SOFT_REMOVED_CARDSDESTINOS = 'cardsdestinos/soft_removed',
  SOFT_REMOVING_CARDSDESTINOS_FAILED = 'cardsdestinos/soft_removing_failed',

  EDIT_CARDSDESTINOS = 'cardsdestinos/edit',
  EDITING_CARDSDESTINOS = 'cardsdestinos/editing',
  EDITED_CARDSDESTINOS = 'cardsdestinos/edited',
  EDITING_CARDSDESTINOS_FAILED = 'cardsdestinos/editing_failed',

  VIEW_CARDSDESTINOS = 'cardsdestinos/view',
  VIEWING_CARDSDESTINOS = 'cardsdestinos/viewing',
  VIEWED_CARDSDESTINOS = 'cardsdestinos/viewed',
  VIEWING_CARDSDESTINOS_FAILED = 'cardsdestinos/viewing_failed',
}

export function searchCardsdestinos(searchOptions: TSearchOptions | string, keep?: boolean): ISearchCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.SEARCH_CARDSDESTINOS,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingCardsdestinos(): ISearchingCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.SEARCHING_CARDSDESTINOS,
  }
}

export function foundCardsdestinos(cardsdestinos: IpaginatedCardsdestinos, keep?: boolean): IFoundCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.FOUND_CARDSDESTINOS,
    keep: keep,
    payload: {
      cardsdestinos,
    },
  }
}

export function searchingCardsdestinosFailed(): ISearchingCardsdestinosFailedAction {
  return {
    type: CardsdestinosActionTypes.SEARCHING_CARDSDESTINOS_FAILED,
  }
}

export function loadCardsdestinos(loadOptions: TSearchOptions): ILoadCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.LOAD_CARDSDESTINOS,
    loadOptions: loadOptions,
  }
}

export function loadingCardsdestinos(): ILoadingCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.LOADING_CARDSDESTINOS,
  }
}

export function loadedCardsdestinos(cardsdestinos: IpaginatedCardsdestinos): ILoadedCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.LOADED_CARDSDESTINOS,
    payload: {
      cardsdestinos,
    },
  }
}

export function loadingCardsdestinosFailed(): ILoadingCardsdestinosFailedAction {
  return {
    type: CardsdestinosActionTypes.LOADING_CARDSDESTINOS_FAILED,
  }
}

export function addCardsdestinos(carddestino: ICardsdestinosItem): IAddCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.ADD_CARDSDESTINOS,
    payload: carddestino,
  }
}

export function addingCardsdestinos(): IAddingCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.ADDING_CARDSDESTINOS,
  }
}

export function addedCardsdestinos(cardsdestinos: IpaginatedCardsdestinos): IAddedCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.ADDED_CARDSDESTINOS,
    payload: {
      cardsdestinos,
    },
  }
}

export function addingCardsdestinosFailed(errData: { data: { message: string; field?: string }; status: number }): IAddingCardsdestinosFailedAction {
  return {
    type: CardsdestinosActionTypes.ADDING_CARDSDESTINOS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeCarddestino(carddestino: ICardsdestinosItem): IRemoveCarddestinoAction {
  return {
    type: CardsdestinosActionTypes.REMOVE_CARDDESTINO,
    payload: carddestino,
  }
}

export function removingCarddestino(): IRemovingCarddestinoAction {
  return {
    type: CardsdestinosActionTypes.REMOVING_CARDDESTINO,
  }
}

export function removedCarddestino(): IRemovedCarddestinoAction {
  return {
    type: CardsdestinosActionTypes.REMOVED_CARDDESTINO,
  }
}

export function removingCarddestinoFailed(): IRemovingCarddestinoFailedAction {
  return {
    type: CardsdestinosActionTypes.REMOVING_CARDDESTINO_FAILED,
  }
}

export function softRemoveCardsdestinos(carddestino: ICardsdestinosItem): ISoftRemoveCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.SOFT_REMOVE_CARDSDESTINOS,
    payload: carddestino,
  }
}

export function softRemovingCardsdestinos(): ISoftRemovingCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.SOFT_REMOVING_CARDSDESTINOS,
  }
}

export function softRemovedCardsdestinos(carddestino: ICardsdestinosItem): ISoftRemovedCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.SOFT_REMOVED_CARDSDESTINOS,
    payload: carddestino,
  }
}

export function softRemovingCardsdestinosFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingCardsdestinosFailedAction {
  return {
    type: CardsdestinosActionTypes.SOFT_REMOVING_CARDSDESTINOS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editCardsdestinos(carddestino: ICardsdestinosItem): IEditCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.EDIT_CARDSDESTINOS,
    payload: carddestino,
  }
}

export function editingCardsdestinos(): IEditingCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.EDITING_CARDSDESTINOS,
  }
}

export function editedCardsdestinos(cardsdestinos: ICardsdestinosItem): IEditedCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.EDITED_CARDSDESTINOS,
    payload: cardsdestinos,
  }
}

export function editingCardsdestinosFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IEditingCardsdestinosFailedAction {
  return {
    type: CardsdestinosActionTypes.EDITING_CARDSDESTINOS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewCardsdestinos(carddestino: ICardsdestinosItem): IViewCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.VIEW_CARDSDESTINOS,
    payload: carddestino,
  }
}

export function viewingCardsdestinos(): IViewingCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.VIEWING_CARDSDESTINOS,
  }
}

export function viewedCardsdestinos(cardsdestinos: ICardsdestinosItem): IViewedCardsdestinosAction {
  return {
    type: CardsdestinosActionTypes.VIEWED_CARDSDESTINOS,
    payload: cardsdestinos,
  }
}

export function viewingCardsdestinosFailed(): IViewingCardsdestinosFailedAction {
  return {
    type: CardsdestinosActionTypes.VIEWING_CARDSDESTINOS_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchCardsdestinosAction {
  type: CardsdestinosActionTypes.SEARCH_CARDSDESTINOS
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingCardsdestinosAction {
  type: CardsdestinosActionTypes.SEARCHING_CARDSDESTINOS
}

export interface IFoundCardsdestinosAction {
  type: CardsdestinosActionTypes.FOUND_CARDSDESTINOS
  keep?: boolean
  payload: {
    cardsdestinos: IpaginatedCardsdestinos
  }
}

export interface ISearchingCardsdestinosFailedAction {
  type: CardsdestinosActionTypes.SEARCHING_CARDSDESTINOS_FAILED
}

export interface ILoadCardsdestinosAction {
  type: CardsdestinosActionTypes.LOAD_CARDSDESTINOS
  loadOptions: TSearchOptions
}

export interface ILoadingCardsdestinosAction {
  type: CardsdestinosActionTypes.LOADING_CARDSDESTINOS
}

export interface ILoadedCardsdestinosAction {
  type: CardsdestinosActionTypes.LOADED_CARDSDESTINOS
  payload: {
    cardsdestinos: IpaginatedCardsdestinos
  }
}

export interface ILoadingCardsdestinosFailedAction {
  type: CardsdestinosActionTypes.LOADING_CARDSDESTINOS_FAILED
}

export interface IAddCardsdestinosAction {
  type: CardsdestinosActionTypes.ADD_CARDSDESTINOS
  payload: ICardsdestinosItem
}

export interface IAddingCardsdestinosAction {
  type: CardsdestinosActionTypes.ADDING_CARDSDESTINOS
}

export interface IAddedCardsdestinosAction {
  type: CardsdestinosActionTypes.ADDED_CARDSDESTINOS
  payload: {
    cardsdestinos: IpaginatedCardsdestinos
  }
}

export interface IAddingCardsdestinosFailedAction {
  type: CardsdestinosActionTypes.ADDING_CARDSDESTINOS_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveCarddestinoAction {
  type: CardsdestinosActionTypes.REMOVE_CARDDESTINO
  payload: ICardsdestinosItem
}

export interface IRemovingCarddestinoAction {
  type: CardsdestinosActionTypes.REMOVING_CARDDESTINO
}

export interface IRemovedCarddestinoAction {
  type: CardsdestinosActionTypes.REMOVED_CARDDESTINO
}

export interface IRemovingCarddestinoFailedAction {
  type: CardsdestinosActionTypes.REMOVING_CARDDESTINO_FAILED
}

export interface ISoftRemoveCardsdestinosAction {
  type: CardsdestinosActionTypes.SOFT_REMOVE_CARDSDESTINOS
  payload: ICardsdestinosItem
}

export interface ISoftRemovingCardsdestinosAction {
  type: CardsdestinosActionTypes.SOFT_REMOVING_CARDSDESTINOS
}

export interface ISoftRemovedCardsdestinosAction {
  type: CardsdestinosActionTypes.SOFT_REMOVED_CARDSDESTINOS
  payload: ICardsdestinosItem
}

export interface ISoftRemovingCardsdestinosFailedAction {
  type: CardsdestinosActionTypes.SOFT_REMOVING_CARDSDESTINOS_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditCardsdestinosAction {
  type: CardsdestinosActionTypes.EDIT_CARDSDESTINOS
  payload: ICardsdestinosItem
}

export interface IEditingCardsdestinosAction {
  type: CardsdestinosActionTypes.EDITING_CARDSDESTINOS
}

export interface IEditedCardsdestinosAction {
  type: CardsdestinosActionTypes.EDITED_CARDSDESTINOS
  payload: ICardsdestinosItem
}

export interface IEditingCardsdestinosFailedAction {
  type: CardsdestinosActionTypes.EDITING_CARDSDESTINOS_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewCardsdestinosAction {
  type: CardsdestinosActionTypes.VIEW_CARDSDESTINOS
  payload: ICardsdestinosItem
}

export interface IViewingCardsdestinosAction {
  type: CardsdestinosActionTypes.VIEWING_CARDSDESTINOS
}

export interface IViewedCardsdestinosAction {
  type: CardsdestinosActionTypes.VIEWED_CARDSDESTINOS
  payload: ICardsdestinosItem
}

export interface IViewingCardsdestinosFailedAction {
  type: CardsdestinosActionTypes.VIEWING_CARDSDESTINOS_FAILED
}

export type CardsdestinosAction =
  | ISearchCardsdestinosAction
  | ISearchingCardsdestinosAction
  | IFoundCardsdestinosAction
  | ISearchingCardsdestinosFailedAction
  | ILoadCardsdestinosAction
  | ILoadingCardsdestinosAction
  | ILoadedCardsdestinosAction
  | ILoadingCardsdestinosFailedAction
  | IAddCardsdestinosAction
  | IAddingCardsdestinosAction
  | IAddedCardsdestinosAction
  | IAddingCardsdestinosFailedAction
  | IRemoveCarddestinoAction
  | IRemovingCarddestinoAction
  | IRemovedCarddestinoAction
  | IRemovingCarddestinoFailedAction
  | ISoftRemoveCardsdestinosAction
  | ISoftRemovingCardsdestinosAction
  | ISoftRemovedCardsdestinosAction
  | ISoftRemovingCardsdestinosFailedAction
  | IEditCardsdestinosAction
  | IEditingCardsdestinosAction
  | IEditedCardsdestinosAction
  | IEditingCardsdestinosFailedAction
  | IViewCardsdestinosAction
  | IViewingCardsdestinosAction
  | IViewedCardsdestinosAction
  | IViewingCardsdestinosFailedAction
